<template>
    <div class="md-layout">
        <div class="md-layout-item">
            <form>
                <md-card>
                    <md-card-header
                            class="md-card-header-icon"
                            :class="getClass(headerColor)"
                    >
                        <div class="card-icon">
                            <md-icon>translate</md-icon>
                        </div>
                        <h4 class="title">
                            {{ $t(`muc.${oper}`) }}
                            <small></small>
                        </h4>
                    </md-card-header>
                    <md-card-content>
                        <div class="md-layout md-size-50">
                            <div class="md-layout-item md-small-size-100 md-size-50">
                                <div class="md-layout-item md-small-size-100 md-size-50">
                                    <md-field
                                            v-for="field in fields"
                                            :key="field"

                                    >
                                        <label>
                                            {{ $t(`muc.${field}`) }}
                                        </label>
                                        <md-input
                                                v-model="muc[field]"
                                                :type="`${field}`"
                                                :data-vv-name="`${field}`"
                                                @input="onFieldChange(field)"
                                        ></md-input>
                                    </md-field>
                                    <md-field v-if="oper==='add'">
                                        <label for="fillFrom">{{ $t('muc.fill_from') }}</label>
                                        <md-select v-model="mucFillFrom" name="fillFrom" id="fillFrom">
                                            <md-option :value="null">{{ $t('label.none') }}</md-option>
                                            <md-option v-for="muc in mucList" :key="muc.muc_id" :value="muc.muc_id">{{ muc.muc_name }} /
                                                {{ muc.year }}
                                            </md-option>

                                        </md-select>
                                    </md-field>

                                </div>
                            </div>
                            <div class="md-layout-item md-size-100 text-right">
                                <md-button
                                        class="md-success"
                                        native-type="submit"
                                        @click.native.prevent="validate"
                                        :disabled="nothingSave"
                                >
                                    {{ $t('button.save') }}
                                </md-button>
                                <md-button class="md-accent" @click.stop.prevent="onCancel">
                                    {{ $t('button.close') }}
                                </md-button>
                            </div>
                        </div>
                    </md-card-content>
                </md-card>
            </form>
        </div>
    </div>
</template>
<script>
import {mapState} from 'vuex'
//import {SlideYDownTransition} from 'vue2-transitions'
import Swal from 'sweetalert2'

export default {
    name: 'muc-profile-form',
    props: {
        headerColor: {
            type: String,
            default: ''
        },
        oper: String,
        mid: String
    },
    components: {
        //SlideYDownTransition
    },
    async created() {
        if (this.oper === "upd") {
            const {mid} = this.$route.params
            this.muc = await this.$store.dispatch("GET_UNIT_COSTS_BY_ID", mid)
        } else if (this.oper === "add") {
            this.mucList = await this.$store.dispatch("LOAD_UNIT_COSTS_TABLE_LIST")
        }
    },
    data() {
        return {
            pid: null,
            nothingSave: true,
            muc: {},
            mucFillFrom: null,
            mucList: []
        }
    },
    methods: {
        onFieldChange() {
            this.nothingSave = false
        },
        onCancel() {
            this.$router.go(-1)
        },
        getClass: function () {
            //return 'md-card-header-' + headerColor + ''
        },
        async validate() {
            const alert = {
                type: 'success',
                text: '',
                footer: ''
            }

            const {muc_name, muc_id, year} = this.muc
            try {
                if (this.oper === "add") {
                    const data = {muc_name, year: +year}
                    if (this.mucFillFrom !== null) {
                        data["fill_from_id"] = this.mucFillFrom
                    }
                    await this.$store.dispatch('ADD_UNIT_COSTS', {data})
                    alert.text = this.$t(`muc.record_was_added`)
                } else if (this.oper === "upd") {
                    await this.$store.dispatch('UPD_UNIT_COSTS', {id: muc_id, data: {muc_name, year: +year}})
                    alert.text = this.$t(`muc.record_was_updated`)
                } else {
                    throw "Unknown operation"
                }

                this.nothingSave = true
                Swal.fire(alert).then(() => {
                    //this.touched.category = false
                    this.$nextTick(() => this.$validator.reset())
                })
            } catch (err) {
                console.log(err)
                alert.type = 'error'
                if (this.oper === "add") {
                    alert.text = this.$t(`muc.record_was_not_added`)
                } else if (this.oper === "upd") {
                    alert.text = this.$t(`muc.record_was_not_updated`)
                }

                // alert.footer = this.$t(err)
                await Swal.fire(alert)
            }
        }
    },
    watch: {},

    computed: {
        ...mapState({}),
        fields() {
            return ['muc_name', 'year']
        }
    }
}
</script>
<style>
.md-button + .md-button {
    margin-left: 10px;
}
</style>
